import { ALL_CALCULATIONS } from "@suse-o11y/calculate-value-from-points";
import { filter } from "@suse-o11y/filter";
import { identity } from "@suse-o11y/identity";
import { ImmutableSet } from "@suse-o11y/immutable-set";
import { isPresent } from "@suse-o11y/is-present";
import { sortBy } from "@suse-o11y/sort-by";
import { z } from "zod";

import type { Settings } from "../../../components/widget-form/legend/settings";
import { ALL_MODES, ALL_POSITIONS, DEFAULT } from "../../../components/widget-form/legend/settings";
import { partial, tuple } from "../../_decoders";
import { Encoder } from "../../_encoder";

const decoder = tuple([
	z.boolean().optional().catch(undefined),

	z.enum(ALL_POSITIONS).optional().catch(undefined),

	z.enum(ALL_MODES).optional().catch(undefined),

	z
		.array(z.enum(ALL_CALCULATIONS).optional().catch(undefined))
		.transform(filter(isPresent))
		.transform(ImmutableSet.fromArray)
		.optional()
		.catch(undefined),
])
	.transform(([show, position, mode, columns]) => partial<Settings>({ show, position, mode, columns }))
	.catch(undefined);

function encoder(settings: undefined | Settings): Encoder {
	return Encoder.tuple(
		Encoder.primitive(settings?.show, DEFAULT.show),
		Encoder.primitive(settings?.position, DEFAULT.position),
		Encoder.primitive(settings?.mode, DEFAULT.mode),

		Encoder.list(
			// the legend table columns definition is order agnostic
			sortBy(settings?.columns?.toArray() ?? DEFAULT.columns.toArray(), identity),
			sortBy(DEFAULT.columns.toArray(), identity),
			(calculation) => Encoder.primitive(calculation),
		),
	);
}

export { decoder, encoder };
